import type { ReconciliationRun } from 'src/interfaces/reconciliation'
import type { State } from '../reducers/types'

export const getReconciliationRun = (state: State): ReconciliationRun | null => {
  return state.reconciliation.lastRun
}

export const getReconciliationRunning = (state: State): boolean => {
  return state.reconciliation.running
}

export const getReconciliationError = (state: State): string | null => {
  return state.reconciliation.error
}
